import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function FinalTerminateConfirmModal({status, setStatus}) {

  const navigate = useNavigate();
  const deliveryReducer = useSelector(state => state.deliveryReducer);
  
  const closeModal = () => {
    setStatus(false);
    navigate("/delivery");
  };

  return (
    <>
      <div className={ status ? "modal smallModal active" : "modal smallModal" }>
        <div className="modalNoHeader">
          <div className="modalTxt1">
            최종 배송일은 {deliveryReducer.dSelectedDate}, 최종 수거일은 {deliveryReducer.cSelectedDate}입니다.<br/>
            캐비닛 최종 수거가 완료되면 서비스가 해지됩니다.<br/>
            약속된 수거일에 캐비닛이 수거되지 않으면 추가 요금이 결제될 수 있으니 꼭 확인해 주세요.<br/>
            이용해 주셔서 고맙습니다!
          </div>
        </div>

        <div className="modalButtons">
          <div className="inside">
            <button tabIndex={0} className="buttonDone" title="" onClick={closeModal}>확인</button>
          </div>
        </div>
      </div>

      <button tabIndex={0} className={ status ? "dimm active" : "dimm" } title="닫기" onClick={closeModal}></button>
    </>
  );
}

export default FinalTerminateConfirmModal;